export function capitalizeFirstLetter(string) {
	const firstLetter = string.charAt(0).toUpperCase()
	const restOfString = string.slice(1)
	return firstLetter + restOfString
}
